import { useTranslation } from "react-i18next";
import DownloadReportButton from "../../../../components/DownloadReportButton";
import Tabs from "../../../../components/Tabs";

const CarriersReport = () => {
	const { t } = useTranslation();

	const tabs = [
		{
			label: t("carriers"),
			content: (
				<DownloadReportButton
					slug="/api/user/stats/downloadReport"
					text={t("download_report")}
				/>
			),
		},
	];

	return <Tabs ariaLabel={t("carriers")} tabs={tabs} />;
};

export default CarriersReport;
